import { type ReactNode } from "react";
import { HomeSettingIcon, PencilPaperIcon, TaskSearchIcon } from "vega-icons";

import { m } from "@vega-core/paraglide/messages";

export type Tile = {
  icon: ReactNode;
  title: string;
  description: string;
};

export const CoInvestmentsLPWelcomeStepsTiles = (
  companyName: string,
): Tile[] => [
  {
    icon: <TaskSearchIcon />,
    title: m.coInvestments_lp_welcome_landing_browseTitle(),
    description: m.coInvestments_lp_welcome_landing_browseDescription({
      companyName,
    }),
  },
  {
    icon: <PencilPaperIcon />,
    title: m.coInvestments_lp_welcome_landing_subscribeTitle(),
    description: m.coInvestments_lp_welcome_landing_subscribeDescription(),
  },
  {
    icon: <HomeSettingIcon />,
    title: m.coInvestments_lp_welcome_landing_operationsTitle(),
    description: m.coInvestments_lp_welcome_landing_operationsDescription(),
  },
];
